<template>
  <div v-if="productDetails.isProductModifaceEnabled && modifaceSettings.isModifaceEnabled">
    <div v-show="showVTO" ref="showModiface" id="modiface_tryon_container" :class="smallScreen ? 'vto_frame_mobile' : 'vto_frame_desktop'"/>
    <div v-show="!showVTO" class="row">
      <div class="column">
        <button class="vto-button" @click="showModifaceFrame('live')">{{ liveCameraTxt }}</button>
      </div>
      <div class="column">
        <span>
          <input
            @change="convertImageDataForModiface()"
            @onblur="showVTO=false"
            type="file"
            id="input"
            ref="upload"
            style="display: none"
            class="button"
            v-if="uploadReady"
            accept="image/*">
          <button class="vto-button" @click="showModifaceFrame('photo')">
            <span>{{ uploadImageTxt }}</span>
          </button>
        </span>
      </div>
    </div>
  </div>
</template>

<script>
  export default {
    name: 'virtual-tryon',
    props: {
      modifaceSettings: { type: Object, required: false },
      productDetails: { type: Object, required: false },
      productCategory: { type: Object, required: false },
      upcList: { type: Array, required: false },
      colorsList: { type: Array, required: false },
      liveCameraText: { type: String, required: false },
      uploadImageText: { type: String, required: false }
    },
    data() {
      return {
        frameName: 'mf_ppa_frame',
        showVTO: false,
        uploadReady: true,
        fillQuad: [],
        similarShades: [],
        smallScreen: !window.matchMedia('(min-width: 1024px)').matches,
        activeShade: {
          upc: '',
          shadeName: '',
          prodName: ''
        },
        upcData: [],
        product: null,
        liveCameraTxt: null,
        uploadImageTxt: null,
      };
    },
    created() {
      this.liveCameraTxt = this.liveCameraText ? this.liveCameraText : '';
      this.uploadImageTxt = this.uploadImageText ? this.uploadImageText : '';
      const vm = this;
      this.modifacePop();
      if (this.colorsList && this.colorsList !== null && this.colorsList !== undefined && this.colorsList.length !== 0) {
        this.product = {
          id: this.colorsList[0].tagging.ecommerce.detail.products[0].id,
          price: this.colorsList[0].tagging.ecommerce.detail.products[0].price,
          category: this.colorsList[0].tagging.ecommerce.detail.products[0].category,
          brand: this.colorsList[0].tagging.ecommerce.detail.products[0].brand,
          variant: this.colorsList[0].tagging.ecommerce.detail.products[0].variant,
          name: this.colorsList[0].tagging.ecommerce.detail.products[0].name,
          hex: this.colorsList[0].hex,
          eventLabel: this.colorsList[0].tagging.eventLabel
        };
        this.activeShade = {
          upc: vm.colorsList[0].ean,
          shadeName: vm.colorsList[0].name,
          prodName: vm.productDetails ? vm.productDetails.prodName : ''
        };
      }
      if (this.upcList && this.upcList !== null && this.upcList !== undefined) {
        this.upcData = this.upcList;
      }
    },
    mounted() {
      window.eventBus.$on('showVTO',() => {
        setTimeout(() => {
          this.showVTO = false;
        }, 300);
      });
      const vm = this;
      this.$nextTick(() => {
        window.eventBus.$on('selectActiveShade', data => {
          this.product = {
            id: data.tagging.ecommerce.detail.products[0].id,
            price: data.tagging.ecommerce.detail.products[0].price,
            category: data.tagging.ecommerce.detail.products[0].category,
            brand: data.tagging.ecommerce.detail.products[0].brand,
            variant: data.tagging.ecommerce.detail.products[0].variant,
            name: data.tagging.ecommerce.detail.products[0].name,
            hex: data.hex,
            eventLabel: data.tagging.eventLabel
          };
          vm.activeShade = {
            upc: data.ean,
            shadeName: data.name,
            prodName: vm.productDetails.prodName
          };
          if (
            !!window.MF_CHANNEL_PARENT &&
            typeof window.MF_CHANNEL_PARENT === 'object'
          ) {
            vm.UPCChange(vm.activeShade);
          }
        });
      });
      /* istanbul ignore next */
      eventBus.$on('mediaquery::changed', () => {
        this.smallScreen = !window.matchMedia('(min-width: 1024px)').matches;
      });
      window.initModiface = () => {
        // eslint-disable-next-line no-undef
        MF_CHANNEL_PARENT.addFrame({
          frameName: 'mf_ppa_frame',
          divId: 'modiface_tryon_container',
          category: vm.modifaceSettings.category,
          publisherId: vm.modifaceSettings.publisherID,
          country: vm.modifaceSettings.country,
          cmsCountry: vm.modifaceSettings.cmsCountry,
          language: vm.modifaceSettings.language,
          upcList: vm.upcData,
          selectedUpc: vm.activeShade
        });
        // eslint-disable-next-line no-undef
        MF_CHANNEL_PARENT.listen('frame_ready', function(data) {
          document.cookie = 'vtoActivated=true';
        });
        // eslint-disable-next-line no-undef
        MF_CHANNEL_PARENT.send(
          {
            event: 'exit'
          },
          'mf_ppa_frame'
        );
        // eslint-disable-next-line no-undef
        MF_CHANNEL_PARENT.listen(
          'exit',
          () => {
            window.eventBus.$emit('hideVTO', false);
            vm.showVTO = false;
          },
          'mf_ppa_frame'
        );
        // eslint-disable-next-line no-undef
        MF_CHANNEL_PARENT.listen('event_tracking', data => {
          if (data.trackingType === 'quadCta' && data.actionType === 'open') {
            vm.getQuadView();
          }
        });
        // eslint-disable-next-line no-undef
        MF_CHANNEL_PARENT.send(
          {
            event: 'modify_iframe_cta_display',
            data: {
              beforeAfterCta: {
                display: true
              },
              quadCta: {
                display: true
              },
              shareCta: {
                display: true
              }
            }
          },
          'mf_ppa_frame'
        );
        MF_CHANNEL_PARENT.listen('event_tracking', function(data) {
          switch (data.trackingType) {
            case 'uploadPhotoCtaLoaded':
              const uploadCta = {
                event: 'uaevent',
                ecommerce: 'undefined',
                eventCategory: `virtual try on::modiface::${vm.productCategory}`,
                eventAction: 'select',
                eventLabel: 'upload a photo'
              };
              window.dataLayer.push(uploadCta);
              break;
            case 'liveCameraCtaLoaded':
              const liveCamera = {
                event: 'uaevent',
                ecommerce: 'undefined',
                eventCategory: `virtual try on::modiface::${vm.productCategory}`,
                eventAction: 'select',
                eventLabel: 'live camera'
              };
              window.dataLayer.push(liveCamera);
              break;
            case 'compareCta':
              const compareCTA = {
                event: 'uaevent',
                ecommerce: 'undefined',
                eventCategory: `virtual try on::modiface::${vm.productCategory}`,
                eventAction: 'select',
                eventLabel: 'makeup slider'
              };
              window.dataLayer.push(compareCTA);
              break;
            case 'quadCta':
              const quadCTA = {
                event: 'uaevent',
                ecommerce: 'undefined',
                eventCategory: `virtual try on::modiface::${vm.productCategory}`,
                eventAction: 'select',
                eventLabel: 'show tiles'
              };
              window.dataLayer.push(quadCTA);
              break;
            case 'shareCta':
              const shareCTA = {
                event: 'uaevent',
                ecommerce: 'undefined',
                eventCategory: `virtual try on::modiface::${vm.productCategory}`,
                eventAction: 'select',
                eventLabel: 'social share'
              };
              window.dataLayer.push(shareCTA);
              break;
            case 'shareTo':
              const shareTO = {
                event: 'socialInt',
                event_name: 'social_interaction',
                ecommerce: 'undefined',
                socialAction: data.socialAction,
                socialNetwork: data.socialNetwork.toLowerCase(),
                socialTarget: data.socialTarget,
                social_network: data.socialNetwork.toLowerCase(),
                social_action: data.socialAction

              };
              window.dataLayer.push(shareTO);
              break;
            case 'shareDownload':
              const shareDown = {
                event: 'uaevent',
                ecommerce: 'undefined',
                eventCategory: `virtual try on::modiface::${vm.productCategory}`,
                eventAction: 'download',
                eventLabel: 'your photo',
              };
              window.dataLayer.push(shareDown);
              break;
            case 'confirmShare':
              const confirmCTA = {
                event: 'uaevent',
                ecommerce: 'undefined',
                eventCategory: `virtual try on::modiface::${vm.productCategory}`,
                eventAction: 'select::share',
                eventLabel: data.confirmShareActivation
              };
              window.dataLayer.push(confirmCTA);
              break;
            case 'exitCta':
              const exitCTA = {
                event: 'uaevent',
                ecommerce: 'undefined',
                eventCategory: `virtual try on::modiface::${vm.productCategory}`,
                eventAction: 'exit',
                eventLabel: 'exit',
              };
              window.dataLayer.push(exitCTA);
              break;
            case 'errorEvent':
              const errorCTA = {
                event: 'uaevent',
                ecommerce: 'undefined',
                eventCategory: `virtual try on::modiface::${vm.productCategory}`,
                eventAction: 'error',
                eventLabel: data.errorType,
              };
              window.dataLayer.push(errorCTA);
              break;
          }
        });
      };
    },
    methods: {
      modifacePop() {
        if (this?.modifaceSettings?.URL) {
          const modifaceScript = document.createElement('script');
          modifaceScript.setAttribute('src', this.modifaceSettings.URL);
          document.head.appendChild(modifaceScript);
        }
      },
      showModifaceFrame(mode) {
        document.getElementById('modiface_tryon_container').style.display =
          'block';
        window.eventBus.$emit('checkTryiton', true);
        if (mode === 'live') {
          this.showVTO = true;
          MF_CHANNEL_PARENT.send(
            { event: 'mode_change', data: { mode: 'live' } },
            this.frameName
          );
        } else {
          this.showVTO = false;
          window.eventBus.$emit('showPDP', false);
          document.getElementById('modiface_tryon_container').style.display =
            'none';
          this.$refs.upload.click();
        }
        this.iframeLoadEvent();
        this.vtoLoadEvent();
        this.VtoInitalize();
      },
      convertImageDataForModiface() {
      const upload = this.$refs.upload; // eslint-disable-line
        const file = upload.files[0];
        const reader = new FileReader();
        if (file && file.type.match('image.*')) {
          this.showVTO = true;
          window.eventBus.$emit('showPDP', true);
          reader.readAsDataURL(file);
        }
        reader.onload = () => {
          // eslint-disable-next-line no-undef
          MF_CHANNEL_PARENT.send(
            {
              event: 'mode_change',
              data: {
                mode: 'upload',
                img: reader.result
              }
            },
            'mf_ppa_frame'
          );
          this.uploadReady = false;
          this.$nextTick(() => {
            this.uploadReady = true;
          });
        };
        return reader;
      },
      UPCChange(data) {
        // eslint-disable-next-line no-undef
        MF_CHANNEL_PARENT.send(
          {
            event: 'upc_change',
            data: data
          },
          'mf_ppa_frame'
        );
      },
      VtoInitalize() {
        const cd49 = true;
        const element = {
          event: 'uaevent',
          eventCategory: 'Ecommerce',
          eventAction: 'Product Detail|VTO Initialization',
          event_name: 'view_item',
          event_detail: 'variant selection',
        };

        (element.eventLabel = `${this.productDetails.prodName}::by default::${this.product.variant}`),
        (element.product_info = `${this.productDetails.prodName}::by default::${this.product.variant}`),
        (element.ecommerce =
          {
            detail: {
              products: [
                {
                  name: this.product.name.toLowerCase(),
                  id: this.product.id.toLowerCase(),
                  price: this.product.price.toString().toLowerCase(),
                  brand: 'LRP',
                  category: this.product.category.toLowerCase(),
                  variant: this.product.variant.toLowerCase(),
                  dimension35: 'none',
                  dimension36: this.product.hex.toLowerCase(),
                  dimension38: 'none',
                  dimension39: 'none',
                  dimension40: 'none',
                  dimension48: 'none',
                  dimension49: this.getDimension(cd49),
                  dimension91: 'none'
                }
              ]
            }
          }
        );
        window.dataLayer.push(Object.assign({}, JSON.parse(JSON.stringify(element))));
      },
      getDimension(cd49) {
        if (cd49) {
          return 'activated';
        } else {
          if (this.productDetails.isProductModifaceEnabled && this.modifaceSettings.isModifaceEnabled) {
            return 'Present';
          } else {
            return 'Not Present';
          }
        }
      },
      iframeLoadEvent() {
        const iframeLoad = {
          event: 'uaevent',
          ecommerce: 'undefined',
          eventCategory: `virtual try on::modiface::${this.productCategory}`,
          eventAction: 'load',
          eventLabel: 'load'
        };
        window.dataLayer.push(iframeLoad);
      },
      vtoLoadEvent() {
        const element = {
          event: 'uaevent',
          ecommerce: 'undefined',
          eventCategory: `virtual try on::modiface::${this.productCategory}`,
          eventAction: 'virtual try on::select::virtual try on',
          eventLabel: 'load::virtual try on'
        };
        window.dataLayer.push(element);
      }
    }
  };
</script>

<style lang="scss" src="./_vto.scss">
</style>
